import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreatePaymentAllocation } from 'src/features/paymentAllocations/api/useCreatePaymentAllocation';
import { LIST_PAYMENT_ALLOCATIONS_RESOURCE } from 'src/features/paymentAllocations/api/useListPaymentAllocations';
import PaymentAllocationFormModal from 'src/features/paymentAllocations/components/forms/PaymentAllocationFormModal';
import { paymentAllocationMessages } from 'src/features/paymentAllocations/utils/messages';
import { PAYMENT_ALLOCATION_RESOURCE } from 'src/features/paymentAllocations/api/useGetPaymentAllocation';
import { PAYMENT_RESOURCE } from 'src/features/payments/api/useGetPayment';
import { FINANCIAL_DOCUMENT_RESOURCE } from 'src/features/financialDocuments/api/useGetFinancialDocument';

interface CreatePaymentAllocationFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreatePaymentAllocationFormModal<TData>({
    className,
    semantics,
}: CreatePaymentAllocationFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreatePaymentAllocation({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_PAYMENT_ALLOCATIONS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [PAYMENT_ALLOCATION_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [PAYMENT_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [FINANCIAL_DOCUMENT_RESOURCE] });
            toast({
                title: formatMessage(paymentAllocationMessages.createPaymentAllocationSuccess),
                description: formatMessage(paymentAllocationMessages.createPaymentAllocationSuccessDescription),
            });
        },
    });

    return (
        <PaymentAllocationFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(paymentAllocationMessages.addPaymentAllocationSubtitle)}
        />
    );
}

export default CreatePaymentAllocationFormModal;
